import { IconButton, InputAdornment, TextField } from '@material-ui/core'
import { Mic, Stop } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition'
import { Controller } from 'react-hook-form'

export const VoiceTextField = ({
  mounted,
  label,
  name,
  required,
  value,
  setValue,
  controllerProps,
  customOnchange,
  handleCustomOnChange,
  record,
  setRecord,
}: any) => {
  const [fieldName, setFieldName] = useState(null)

  const { transcript, listening, resetTranscript } = useSpeechRecognition()
  useEffect(() => {
    if (!!transcript || transcript !== '') {
      setValue(name, transcript)
    }
  }, [transcript])

  useEffect(() => {
    if (record) {
      resetTranscript()
      SpeechRecognition.startListening({ continuous: true })
    } else {
      SpeechRecognition.stopListening()
    }
  }, [record])

  if (mounted) {
    return (
      <Controller
        render={({ onChange, value: renderValue }) => (
          <TextField
            margin="normal"
            id="stardard-basic"
            label={label}
            name={name}
            {...controllerProps}
            fullWidth
            multiline
            required={required}
            value={renderValue}
            onChange={
              customOnchange
                ? handleCustomOnChange
                : e => {
                    onChange(e)
                  }
            }
            InputLabelProps={{
              shrink: !!renderValue,
            }}
            InputProps={{
              endAdornment:
                listening && fieldName === name ? (
                  <InputAdornment position="start">
                    <IconButton
                      style={{
                        paddingRight: '0px',
                      }}
                      onClick={e => {
                        console.log(e, 'sss')
                        if (listening) {
                          setRecord(false)
                          setFieldName('')
                        } else {
                          setRecord(true)
                        }
                      }}
                    >
                      <div style={{ color: 'red' }}>
                        <Stop />
                      </div>
                    </IconButton>
                  </InputAdornment>
                ) : (
                  <Mic
                    onClick={() => {
                      setRecord(true)
                      setFieldName(name)
                    }}
                  />
                ),
            }}
          />
        )}
        name={name}
        {...controllerProps}
      />
    )
  } else return null
}
